import { QueryContainer, OutlinedButton, SelectDropdown } from '../index';
import { Grid, MenuItem } from '@mui/material';
import { useState } from 'react';

const bigWidth = { width: 250 };

export const DepartmentReports = (props) => {
  const [department, setDepartment] = useState('');

  return (
    <>
      <QueryContainer>
        <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
          <Grid item>
            <SelectDropdown
              sx={{ minWidth: 250 }}
              size="small"
              label="Employee Hours"
              value={department}
              onChange={(event) => setDepartment(event.target.value)}
            >
              {props.departmentList.map((data, index) => (
                <MenuItem key={index} value={data.deptname}>
                  {data.deptname}
                </MenuItem>
              ))}
            </SelectDropdown>
          </Grid>
          <Grid item sx={{ ml: 3 }}>
            <SelectDropdown
              sx={{ minWidth: 250 }}
              size="small"
              label="Projects Worked"
              value={department}
              onChange={(event) => setDepartment(event.target.value)}
            >
              {props.departmentList.map((data, index) => (
                <MenuItem key={index} value={data.deptname}>
                  {data.deptname}
                </MenuItem>
              ))}
            </SelectDropdown>
          </Grid>
          <Grid item sx={{ ml: 3 }}>
            <OutlinedButton
              // onClick={}
              btnTitle="Project Hours"
              style={bigWidth}
            />
          </Grid>
        </Grid>
      </QueryContainer>
    </>
  );
};
